import { useCallback, useEffect, useState } from 'react';
import { showDefaultError } from '../components/molecules/Notifications';
import callApi from './callApi';
import { config } from './config';
import { reportErrorToSentry } from './initializeSentry';
import { pushTrackingEvent } from './tracking';

const useQuery = <T>(endpoint: string, flow?: 'state' | 'legacy') => {
  const [data, setData] = useState<T | undefined>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      const result = await callApi({ endpoint, flow });
      setData(result);
    } catch (e: any) {
      console.error(e);
      reportErrorToSentry(e);
      showDefaultError();
      setError(true);
      pushTrackingEvent({
        event: 'error',
        action: 'fetch_data',
        label: `${config.country}|${e.statusCode}|${e.message}`,
        value: null,
      });
    }
    setLoading(false);
  }, [endpoint, flow]);
  useEffect(() => {
    fetchData();
  }, [endpoint, fetchData]);
  return { data, loading, error, refetch: fetchData, setData };
};

export default useQuery;
